import socket from '@/services/socket.js'

export default {
  /**
   * Get blockable apps.
   *
   * @param user_id
   * @param platform
   * @returns Promise
   */
  getBlockableApps(user_id, platform) {
    const action = "/application/get/blockable_apps"

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        platform,
        user_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.apps)
      })
    })
  },

  /**
   * Get app settings by mode id.
   *
   * @param mode_id
   * @returns Promise
   */
  getAppSettings(mode_id) {
    const action = '/app_setting/get_by_mode_id'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        mode_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.app_settings)
      })
    })
  },

  /**
   * Get social media app settings by user id.
   *
   * @param user_id
   * @returns Promise
   */
  getSocialMediaSettings(user_id) {
    const action = '/user/social_media_settings/get'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Set social media app settings.
   *
   * @param user_id
   * @param app_name
   * @param app_action
   * 
   * @returns Promise
   */
  setSocialMediaSettings(user_id, app_name, app_action) {
    const action = '/user/social_media_settings/set'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id,
        app_name,
        app_action
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data.social_media_setting)
      })
    })
  },

  /**
   * Block all social media apps.
   *
   * @param user_id
   * @returns Promise
   */
  blockAllSocialMedia(user_id) {
    const action = '/user/social_media_settings/block_all'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Allow all social media apps.
   *
   * @param user_id
   * @returns Promise
   */
  allowAllSocialMedia(user_id) {
    const action = '/user/social_media_settings/allow_all'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Block unsupported social media apps.
   *
   * @param user_id
   * @returns Promise
   */
  blockUnsupportedSocialMedia(user_id) {
    const action = '/user/social_media_settings/block_unsupported'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Allow unsupported social media apps.
   *
   * @param user_id
   * @returns Promise
   */
  allowUnsupportedSocialMedia(user_id) {
    const action = '/user/social_media_settings/allow_unsupported'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Set app settings.
   *
   * @param mode_id
   * @param application_id
   * @param action_type
   * @returns Promise
   */
  setAppSettings(mode_id, application_id, action_type) {
    const action = '/app_setting/set'

    let body = {
      mode_id,
      application_id,
      action: action_type
    }

    return new Promise((resolve, reject) => {
      socket.emit(action, { body }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.app_settings[0])
      })
    })
  },

  /**
   * Block app.
   *
   * @param mode_id
   * @param application_id
   * @returns Promise
   */
  blockApp(mode_id, application_id) {
    return this.setAppSettings(mode_id, application_id, 'block')
  },

  /**
   * Allow app.
   *
   * @param mode_id
   * @param application_id
   * @returns Promise
   */
  allowApp(mode_id, application_id) {
    return this.setAppSettings(mode_id, application_id, 'allow')
  },

  /**
   * Get apps info.
   * @param ids
   * @returns Promise
   */
  getInfo(ids) {
    const apiUrl = 'https://wezift.com/api/v1/apps/ids'

    return axios.get(apiUrl, {
      and_ids: ids.join(',')
    }).then(response => response.data)
  }
}
